var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingCartOrdersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0L4.34 0.2C4.66154 0.214463 4.97048 0.329313 5.22338 0.528408C5.47629 0.727504 5.66045 1.00084 5.75 1.31L8.75 11.88C8.84087 12.2006 9.03327 12.4831 9.29833 12.685C9.56338 12.887 9.88679 12.9975 10.22 13H20",
    transform: "translate(2 3)",
    stroke: "#1E334E",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4034 7.00143H2.56341C2.34155 7.01091 2.12285 6.94628 1.94179 6.81772C1.76072 6.68917 1.6276 6.504 1.56341 6.29143L0.0434069 1.29143C-0.00344525 1.13764 -0.0125275 0.974819 0.0169296 0.816773C0.0463867 0.658726 0.113515 0.510112 0.212624 0.383527C0.311733 0.256943 0.439901 0.156119 0.586264 0.0896036C0.732626 0.023088 0.892869 -0.00715883 1.05341 0.00142731H12.1734C12.3155 0.0004003 12.4561 0.0296532 12.586 0.0872375C12.7158 0.144822 12.832 0.229416 12.9266 0.335385C13.0212 0.441355 13.0921 0.566268 13.1347 0.701805C13.1773 0.837342 13.1905 0.980392 13.1734 1.12143L12.4234 6.12143C12.3936 6.36882 12.2725 6.59618 12.0838 6.75895C11.8951 6.92173 11.6525 7.0082 11.4034 7.00143Z",
    transform: "translate(8.82617 6.49805)",
    stroke: "#1E334E",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 4C3.10457 4 4 3.10457 4 2C4 0.895431 3.10457 0 2 0C0.89543 0 0 0.895431 0 2C0 3.10457 0.89543 4 2 4Z",
    transform: "translate(10.1201 17.3594)",
    fill: "#F7931E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 4C3.10457 4 4 3.10457 4 2C4 0.895431 3.10457 0 2 0C0.895429 0 0 0.895431 0 2C0 3.10457 0.895429 4 2 4Z",
    transform: "translate(17.2998 17.3594)",
    fill: "#F7931E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCartOrdersIcon);
export default __webpack_public_path__ + "static/media/ShoppingCart_Orders_Icon.3df6f4f8a6f1895910c77287eaeae2a8.svg";
export { ForwardRef as ReactComponent };